/**
 * Conta as palavras de um texto em francês de forma mais precisa e pedagógica.
 * Trata apóstrofos franceses separando-os (ex: "J'aime" = 2 palavras, "l'école" = 2 palavras),
 * mas preserva termos compostos específicos conhecidos (ex: "aujourd'hui" = 1 palavra).
 * 
 * @param text O texto a ser analisado
 * @returns Quantidade de palavras contadas
 */
export function countFrenchWords(text: string | null | undefined): number {
  if (!text) return 0;

  // 1. Padronizar apóstrofos curvos para retos
  let cleaned = text.replace(/’/g, "'");

  // 2. Mascarar "aujourd'hui" temporariamente para evitar separação
  cleaned = cleaned.replace(/aujourd'hui/gi, "aujourd_hui");

  // 3. Substituir qualquer apóstrofo restante por um espaço para separar contrações (j'aime -> j aime)
  cleaned = cleaned.replace(/'/g, " ");

  // 4. Dividir por qualquer espaçamento branco e ignorar itens vazios
  const words = cleaned.trim().split(/\s+/).filter(w => w.length > 0);

  return words.length;
}

/**
 * Normalizes a grammar answer by removing trailing punctuation,
 * extra spaces, standardizing apostrophes, and converting to lowercase.
 * Useful for fill_blank and transformation exercises.
 */
export function normalizeGrammarAnswer(answer: string | null | undefined): string {
  if (!answer) return "";
  
  let normalized = answer.trim().toLowerCase();
  
  // Normalize apostrophes
  normalized = normalized.replace(/’/g, "'");
  
  // Replace multiple spaces with a single space
  normalized = normalized.replace(/\s+/g, " ");
  
  // Remove trailing punctuation (., !, ?, ;, :)
  normalized = normalized.replace(/[.!?;\:]+$/, "");
  
  return normalized.trim();
}
